import React from 'react';
import ReactDOM from 'react-dom';

class Subtitle extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('span');
  }

  componentDidMount() {
    this.root = document.getElementsByTagName('h1')[0];
    this.root.appendChild(this.el);
  }

  componentWillUnmount() {
    this.root.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

export default Subtitle;
